<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Supplier
          </div>

          <v-row
            class="">
            <v-col 
              cols="10"
              class="px-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>
                        
                        <v-col
                        cols="12"
                        md="6" class="pt-0 pr-8">

                          <ValidationProvider
                            name="Nama Lengkap Penanggungjawab" 
                            rules="" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama Lengkap Penanggungjawab
                            </div>
      
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Nama PIC"
        
                              
        
                              v-model="form.pic_name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Nama Perusahaan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Nama Perusahaan
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Nama Perusahaan"
        
                              
        
                              v-model="form.name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                          
                          <ValidationProvider
                            name="No KTP" 
                            rules="required|min:16|max:16" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              No KTP
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"
        
                              placeholder="No. KTP"
        
                              
        
                              v-model="form.nik"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Alamat" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Alamat
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
                              row="2"
        
                              color="#718EBF"
                              placeholder="Alamat"
        
                              
        
                              v-model="form.address"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>

                        </v-col>
                        
                        <v-col
                          cols="12"
                          md="6" class="pt-0 pl-8">

                          <ValidationProvider
                            name="NPWP" 
                            rules="required|min:15|max:16" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              NPWP
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"
        
                              placeholder="NPWP"
        
                              
        
                              v-model="form.npwp"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Email
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Contoh. XXXX@gmail.com"
                              
        
                              v-model="form.email"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Mobilephone" 
                            rules="required|min:10|max:13" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->
                              Mobilephone
                            </div>

                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo

                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              placeholder="Contoh. 081XXXXXXXXX"

                              

                              v-model="form.mobilephone"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>


                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/user/supplier"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,


        form: {
          name: '',
          mobilephone: '',
          address: '',
          pic_name: '',
          email: '',
          nik: '',
          npwp: '',
        },
        category: [],
        supervisor: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          ttd: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ttd': {
        handler: function () {
          if (this.upload.ttd) {
            this.process.ttd = this.upload.ttd.process

            if (!this.process.ttd) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.ttd = this.upload.ttd.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchCatrgory()
      this.fetchCabang()
      this.fetchSupervisor()
    },
    methods: {
      async fetchCatrgory() {

         let params = {
          limit: 10000000000000,
          'id[nin]': '1,8'
        }

        await get(`admin/category_user/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },
      async fetchCabang() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/branch/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.branch = res.results.data
          }
        })
      },
      async fetchSupervisor() {

         let params = {
          limit: 10000000000000,
          is_active: 'Aktif',
          'category_user_id': '5'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.supervisor = res.results.data
          }
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/supplier/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/user/supplier' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>